import { useEffect } from "react"

/**
 * Custom hook to update the document title.
 *
 * @param {string} title - The new title for the document.
 *
 * @returns {string} The current document title.
 */
const useDocumentTitle = (title: string): string => {
  useEffect(() => {
    document.title = title
  }, [title])

  return title
}

export default useDocumentTitle
